import ReactDiffViewer from "react-diff-viewer-continued";

import { Modal } from "@virtual-brain-lib/frontend-design-system/ui";

interface DeepDiffModalProps {
	readonly isOpen: boolean;
	readonly close: () => void;
	readonly sourceText: string;
	readonly targetText: string;
	readonly sourceDocumentName?: string;
	readonly targetDocumentName?: string;
}

export function DeepDiffModal({
	isOpen,
	close,
	sourceText,
	targetText,
	sourceDocumentName,
	targetDocumentName,
}: DeepDiffModalProps) {
	const title =
		sourceDocumentName && targetDocumentName
			? `${sourceDocumentName} → ${targetDocumentName}`
			: "Document comparison";

	return (
		<Modal close={close} icon="files" isOpen={isOpen} size="2xl" title={title}>
			<div className="max-h-[70vh] overflow-y-auto rounded border border-secondary-border">
				<ReactDiffViewer
					oldValue={sourceText}
					newValue={targetText}
					splitView={false}
					leftTitle={sourceDocumentName}
					rightTitle={targetDocumentName}
					infiniteLoading={{
						pageSize: 20,
						containerHeight: "60vh",
						overscan: 20,
					}}
					loadingElement={() => (
						<div style={{ padding: "20px", textAlign: "center" }}>
							Computing diff...
						</div>
					)}
				/>
			</div>
		</Modal>
	);
}
